import { splitArrayByIndex } from "app/pages/sales-intelligence/utils/arrays";

import createTooltipColumnsResolver from "../../../../services/table-columns/intent/tooltipColumnsFactory";
import type IntentSignalRowDto from "../../../intent/IntentSignalRowDto";
import type SignalsTooltipViewModel from "../SignalsTooltipViewModel";
import type TooltipTableColumn from "../TooltipTableColumn";

type FactoryDeps = {
    intentTopicScopeList: IntentSignalRowDto[];
    itemsLimit: number;
};

export default function createIntentSignalsTooltipViewModel({
    intentTopicScopeList,
    itemsLimit,
}: FactoryDeps): SignalsTooltipViewModel<IntentSignalRowDto, TooltipTableColumn> {
    const tableColumnsResolver = createTooltipColumnsResolver({
        tableRowData: intentTopicScopeList,
    });

    const isItemLimitReached = intentTopicScopeList.length > itemsLimit;

    const [displayedTopicScopeList, remainingTopicScopeList]: [IntentSignalRowDto[], IntentSignalRowDto[]] =
        isItemLimitReached ? splitArrayByIndex(intentTopicScopeList, itemsLimit) : [intentTopicScopeList, []];

    return {
        get visibleItems(): IntentSignalRowDto[] {
            return displayedTopicScopeList;
        },

        get otherItems(): IntentSignalRowDto[] {
            return remainingTopicScopeList;
        },

        getPresentationDetailList(): TooltipTableColumn[] {
            return tableColumnsResolver.getTableColumns();
        },
    };
}
